import type { ReturnHub } from '@dhl/mdp-api'
import { convertToAddress } from '~/common/components/addresses'
import type { ReturnHub as ClientReturnHub } from '~/modules/returnhubsccc/model'

export const convertToReturnHub = (returnHubDto: ReturnHub): ClientReturnHub => ({
  ...returnHubDto,
  address: convertToAddress(returnHubDto.address),
})
